import { api } from "api";

// ------ Admin endpoints --------------------------------------------------

export const adminListProductVideos = async (params) => {
    const response = await api.get("admin/product-videos", { params });
    return response.data;
};

export const adminUploadProductVideo = async (formData, options = {}) => {
    const response = await api.post("admin/product-videos", formData, {
        timeout: 5 * 60 * 1000, // 5-minute ceiling for large video uploads
        ...options,
    });
    return response.data;
};

export const adminUpdateProductVideo = async (id, body) => {
    const response = await api.patch(`admin/product-videos/${id}`, body);
    return response.data;
};

export const adminDeleteProductVideo = async (id) => {
    const response = await api.delete(`admin/product-videos/${id}`);
    return response.data;
};

// ------ Vendor endpoints -------------------------------------------------

export const vendorListProductVideos = async (params) => {
    const response = await api.get("vendor/product-videos", { params });
    return response.data;
};

export const vendorUploadProductVideo = async (formData, options = {}) => {
    const response = await api.post("vendor/product-videos", formData, {
        timeout: 5 * 60 * 1000,
        ...options,
    });
    return response.data;
};

export const vendorUpdateProductVideo = async (id, body) => {
    const response = await api.patch(`vendor/product-videos/${id}`, body);
    return response.data;
};

export const vendorDeleteProductVideo = async (id) => {
    const response = await api.delete(`vendor/product-videos/${id}`);
    return response.data;
};
